<p class="message">
    <cl-icon [icon]="icon()" class="icon" />
    <span>{{ message() }}</span>
</p>

<ng-content />
